import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

const CurrentPractitionerIsStudent_Shared_Query = gql`
  query CurrentPractitionerIsStudent_Shared_Query {
    currentPractitioner {
      id
      properties {
        id
        isStudent
        isStudentGraduationDateInTheFuture
      }
    }
  }
`;

interface CurrentPractitionerIsStudentData {
  currentPractitioner: {
    id: string;
    properties: {
      isStudent: boolean;
      isStudentGraduationDateInTheFuture: boolean;
    };
  };
}

const useCurrentPractitionerIsStudentQuery = (
  options?: QueryHookOptions<CurrentPractitionerIsStudentData>
) => useQuery<CurrentPractitionerIsStudentData>(CurrentPractitionerIsStudent_Shared_Query, options);

export type { CurrentPractitionerIsStudentData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useCurrentPractitionerIsStudentQuery, CurrentPractitionerIsStudent_Shared_Query };
